import { render, staticRenderFns } from "./GallerySlider.vue?vue&type=template&id=296ad87e&"
import script from "./GallerySlider.vue?vue&type=script&lang=js&"
export * from "./GallerySlider.vue?vue&type=script&lang=js&"
import style0 from "./GallerySlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports